import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { UnitType } from 'entities/Contract';
import { Select } from 'shared/ui/Select';
import { BoxesListFilterKeys } from '../../../../model/types';

interface UnitTypeSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const UnitTypeSelect: FC<UnitTypeSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('boxes');

  const unitTypeOptions = useMemo<Array<{ label: string; value: UnitType }>>(() => {
    return [
      { label: t('Office'), value: UnitType.OFFICE },
      { label: t('Box'), value: UnitType.BOX },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(BoxesListFilterKeys.priceType);
  }, [onClear]);

  return (
    <Select
      containerClassName="basis-1/3"
      className="w-full"
      label={t('Unit type')}
      placeholder={t('Select')}
      bordered
      options={unitTypeOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
